import { apiRequest } from "../lib/apiClient";
import type { ShipmentCreate, ShipmentOut, ShipmentStatusEventOut, ShipmentUpdate } from "./types";

/** `GET /shipments` — any authenticated user. */
export async function listShipments(
  accessToken: string,
  filters: { saleId?: string; invoiceOrBillId?: string } = {},
): Promise<ShipmentOut[]> {
  return apiRequest<ShipmentOut[]>("/shipments", {
    accessToken,
    query: { sale_id: filters.saleId, invoice_or_bill_id: filters.invoiceOrBillId },
  });
}

export async function getShipment(accessToken: string, shipmentId: string): Promise<ShipmentOut> {
  return apiRequest<ShipmentOut>(`/shipments/${shipmentId}`, { accessToken });
}

/** `POST /shipments` — OWNER/BRANCH_MANAGER/ECOM_MGR. */
export async function createShipment(accessToken: string, body: ShipmentCreate): Promise<ShipmentOut> {
  return apiRequest<ShipmentOut>("/shipments", { method: "POST", accessToken, body });
}

/** `PATCH /shipments/{id}` — OWNER/BRANCH_MANAGER/ECOM_MGR. A 409 means an invalid status
 * transition (`shipping_service.VALID_TRANSITIONS`) — never force it through. */
export async function updateShipment(accessToken: string, shipmentId: string, body: ShipmentUpdate): Promise<ShipmentOut> {
  return apiRequest<ShipmentOut>(`/shipments/${shipmentId}`, { method: "PATCH", accessToken, body });
}

/** `GET /shipments/{id}/status-history` — any authenticated user. */
export async function getShipmentStatusHistory(accessToken: string, shipmentId: string): Promise<ShipmentStatusEventOut[]> {
  return apiRequest<ShipmentStatusEventOut[]>(`/shipments/${shipmentId}/status-history`, { accessToken });
}
